/* eslint-disable max-len */

const align = `<g>
  <g transform="translate(-28.000000, -156.000000)">
    <g transform="translate(0.000000, 72.000000)">
      <g transform="translate(28.000000, 84.000000)">
        <rect x="7" y="0" width="2" height="16"></rect>
        <polygon points="5 4 5 12 0 12"></polygon>
        <polygon points="11 4 11 12 16 12"></polygon>
      </g>
    </g>
  </g>
</g>`;

export default align;
